export default __webpack_public_path__ + "img/chevronRightInactive.6b5056d3.svg";